import { render, staticRenderFns } from "./NodeMenuItem.vue.js?vue&type=template&id=133adeaa!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NodeMenuItem.vue?vue&type=template&id=133adeaa"
import script from "./NodeMenuItem.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NodeMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./NodeMenuItem.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NodeMenuItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports